import styled from 'styled-components';

const ProductNotFoundBackButtonWrapper = styled.div`
  text-align: center;
  margin: 0 auto;
  padding: 10px;
  max-width: 300px;
`;

export default ProductNotFoundBackButtonWrapper;
